// Mirrors LIBERTY_USER_MARKERS in app-server's users/models/liberty.py --
// substrings that identify a Liberty Mutual referral by the submitter's email.
// "helmsman" was intentionally dropped (KAB-3474): the only helmsman-named
// entity we see is helmsmantpa.com, a separate TPA that should not receive the
// Liberty Mutual referral fields.
export const LIBERTY_USER_MARKERS = ["liberty"];

// Liberty Mutual referral fields -- shared between the intake wizard and the
// Operations File view (Future Medical Operations/Medical Review sections).
// Values must match the backend's TextChoices exactly (see
// operations/constants.py in app-server).
export const LIBERTY_GRS_OR_LEGACY_RCG_OPTIONS = [
  { value: "", label: "-- Select --" },
  { value: "GRS", label: "GRS" },
  { value: "RCG", label: "RCG" },
  { value: "N/A", label: "N/A" },
];

export const LIBERTY_SEGMENTATION_TYPE_OPTIONS = [
  { value: "", label: "-- Select --" },
  { value: "CST", label: "Claims Service Team (CST)" },
  { value: "CPX", label: "Complex (CPX)" },
  { value: "CSS", label: "Claims Support Service (CSS)" },
  { value: "N/A", label: "N/A" },
];

// Manual-entry-only field, set in Operations (not intake). Values must match
// the backend's LIBERTY_BENEFICIARY_CLASS TextChoices verbatim -- they're
// emitted as-is into Col C of the MSA Supplier Data Report.
export const LIBERTY_BENEFICIARY_CLASS_OPTIONS = [
  { value: "", label: "-- Select --" },
  { value: "Class I", label: "Class I" },
  { value: "Class II", label: "Class II" },
  { value: "Class III", label: "Class III" },
  { value: "Class IV", label: "Class IV" },
];

export const LIBERTY_RCG_CARRIER_OPTIONS = [
  { value: "", label: "-- Select --" },
  { value: "AMERICA_FIRST_INSURANCE", label: "America First Insurance" },
  { value: "COLORADO", label: "Colorado" },
  { value: "GOLDEN_EAGLE", label: "Golden Eagle" },
  { value: "INDIANA_INSURANCE", label: "Indiana Insurance" },
  { value: "MONTGOMERY", label: "Montgomery" },
  { value: "OHIO_CASUALTY", label: "Ohio Casualty" },
  { value: "PEERLESS", label: "Peerless" },
];

export const LIBERTY_REFERRAL_TYPE_OPTIONS = [
  { value: "", label: "-- Select --" },
  { value: "MSA", label: "MSA" },
  { value: "REVISION", label: "Revision" },
  { value: "CMS_SUBMISSION", label: "CMS Submission" },
  { value: "POST_CMS_APPROVAL_RE_EVAL", label: "Post-CMS Approval Re-eval" },
  { value: "FMA", label: "Future Medical Allocation" },
  { value: "N/A", label: "N/A" },
];

// Liberty-only Service Selection addition. Same value as the existing "MCP"
// service option (operations/constants.py SERVICE_TYPE.MCP) -- this is a
// friendlier label for Liberty referrals, not a distinct service type. Both
// options resolve to the same Service.type="MCP" on submission.
export const LIBERTY_FUTURE_MEDICAL_ALLOCATION_SERVICE_OPTION = {
  value: "MCP",
  label: "Future Medical Allocation",
};
